import React from 'react';
import {
  DummyContainer,
  BoardTitle,
  EditableTitle,
  Loader,
  AddNewTaskButton,
  AddNewTaskButtonLabel,
  SectionalContentWrapper,
} from './styles';
import { ADD_NEW_TASK_FOOTER } from '../../../languages/en/notebook';
import ThemeV2 from '../../../theme';

export const DummySection = ({
  isSectionBeingCreated,
  handleSectionCreation,
  autoFocus,
  sectionTitle,
  setSectionTitle,
}: {
  isSectionBeingCreated: boolean;
  handleSectionCreation: (title: string, isBlur?: boolean) => void;
  autoFocus?: boolean;
  sectionTitle: string;
  setSectionTitle: (title: string) => void;
}) => {
  if (isSectionBeingCreated) {
    return (
      <DummyContainer>
        <BoardTitle>
          <EditableTitle
            color={ThemeV2.palette.gray1}
            value={sectionTitle}
            onChange={() => {}}
            disabled
            dummyTitle
          />
          <Loader icon="loader" size="16px" />
        </BoardTitle>
        <AddNewTaskButton disabled>
          <AddNewTaskButtonLabel
            role="button"
            justifyContent="center"
            onClick={() => {}}
          >
            {ADD_NEW_TASK_FOOTER}
          </AddNewTaskButtonLabel>
        </AddNewTaskButton>
      </DummyContainer>
    );
  }
  return (
    <DummyContainer
      onBlur={() => {
        handleSectionCreation('', true);
      }}
    >
      <BoardTitle>
        <EditableTitle
          value={sectionTitle}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            setSectionTitle(e?.target?.value);
          }}
          onKeyPress={(e: React.KeyboardEvent) => {
            if (e.key === 'Enter') {
              handleSectionCreation(sectionTitle);
            }
          }}
          onBlur={() => handleSectionCreation(sectionTitle, true)}
          autoFocus={autoFocus}
          dummyTitle
        />
      </BoardTitle>
      <SectionalContentWrapper>
        <AddNewTaskButton disabled>
          <AddNewTaskButtonLabel
            role="button"
            justifyContent="center"
            onClick={() => {}}
          >
            {ADD_NEW_TASK_FOOTER}
          </AddNewTaskButtonLabel>
        </AddNewTaskButton>
      </SectionalContentWrapper>
    </DummyContainer>
  );
};
